import { createFileRoute } from '@tanstack/react-router';
import { ChatManager } from '../../components/admin/ChatManager';

export const Route = createFileRoute('/admin/chat')({
  component: ChatTab,
});

function ChatTab() {
  return <ChatManager />;
}
